import { useState, useCallback, useLayoutEffect } from 'react';

type UseSizeHook = [
    (node: HTMLAnchorElement) => void,
    Size,
    HTMLElement | null,
];

type Size = 'large' | 'medium' | 'small';

function getSize(node: HTMLElement): Size {
    const rect = node.getBoundingClientRect();

    if (rect.width > 450) {
        return 'large';
    } else if (rect.width > 300) {
        return 'medium';
    } else {
        return 'small';
    }
}

function useSize(): UseSizeHook {
    const [size, setSize] = useState<Size>('small');
    const [node, setNode] = useState<HTMLAnchorElement | null>(null);

    const ref = useCallback((node) => {
        setNode(node);
    }, []);

    useLayoutEffect(() => {
        if (node) {
            const measure = () =>
                window.requestAnimationFrame(() => setSize(getSize(node)));
            measure();

            window.addEventListener('resize', measure);

            return () => {
                window.removeEventListener('resize', measure);
            };
        }
        return () => {};
    }, [node]);

    return [ref, size, node];
}

export default useSize;
